<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  #profileDropdown {
    width: 100%;
    display: flex;
    margin-left: utils.in_rem(4px);
    position: relative;

    button {
      width: 100%;
      background: none;
      border: none;
      outline: none;
      cursor: pointer;
      padding: 0;
      display: flex;
      align-items: center;
      gap: utils.in_rem(8px);

      .avatar-wrapper {
        flex-shrink: 0;
      }

      &:hover .name,
      &:focus .name,
      &:active .name {
        @include colors.background-color(interfaceTransparentWhite_15);
      }

      .name {
        @include colors.color(interfaceTransparentWhite_90);
        @include mixins.sidebar();
        $height: utils.in_rem(32px);
        $padding: utils.in_rem(8px);
        height: $height;
        line-height: calc($height - 2 * $padding);
        margin-right: utils.in_rem(16px);
        padding: $padding;
        border-radius: utils.in_rem(16px);
        white-space: nowrap;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
</style>

<script>
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import Avatar from "../../../components/legacy/Avatar.svelte";
  import DropdownMenu from "../DropdownMenu/DropdownMenu.svelte";
  import { activeDropdown } from "../stores/dropdown-store";
  import { profileMenuItemsStore } from "../stores/profile-menu-store";
  import { sidebarIsExpanded } from "../stores/sidebar-store.js";

  let targetElement;
  let buttonElement;
  $: isOpen = $activeDropdown === "profile";
  $: ({ name = "", picture: image = "" } = $userStore || {});

  $: if (!$sidebarIsExpanded) {
    activeDropdown.set(null);
    if (buttonElement) buttonElement.blur();
  }

  const handleClick = (event) => {
    if (targetElement && targetElement.contains(event.target)) return;
    if (isOpen) activeDropdown.set(null);
  };

  const handleButtonClick = () => {
    activeDropdown.set(isOpen ? null : "profile");
  };
</script>

<svelte:window on:click={handleClick} />

<div id="profileDropdown" bind:this={targetElement}>
  <button
    bind:this={buttonElement}
    on:click|stopPropagation={handleButtonClick}
  >
    <div class="avatar-wrapper">
      <Avatar size="lg" cls="text-white" {name} {image} displayInitials />
    </div>
    {#if $sidebarIsExpanded}
      <span class="name">{name}</span>
    {/if}
  </button>
  {#if isOpen}
    <DropdownMenu
      items={$profileMenuItemsStore}
      type="primary"
      offsetElementId="sidebar"
      {targetElement}
      expanded={$sidebarIsExpanded}
    />
  {/if}
</div>
